import { FC, useMemo } from "react";
import { useStrokeContext } from "../../services/editor/editorContext";
import { AvailableColor, PublicColorKey } from "../../services/editor/ColorPalette";

export const SubmitPreviewImage: FC = () => {

    const { processedBase64, color, availableColors } = useStrokeContext();

    const val = useMemo( () => {

        if ( color === undefined ) {
            return "white";
        }

        return availableColors[color as PublicColorKey];

    }, [color, availableColors] );

    if (!processedBase64) {
        return <></>;
    }

    return <>
        <div style={{
            position: "relative",
            border: "var(--border-width) solid var(--gray)",
            display: "inline-block",
        }}>

            <div style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: val ?? "white",
            }}></div>
            <img
                src={processedBase64}
                alt="Náhled obrázku"
                style={{
                    display: "block",
                    position: "relative",
                    mixBlendMode: "multiply",
                }}
            />

        </div>
    </>
}